"use client"

import { Button } from "@/components/ui/button"
import Link from 'next/link';
import Image from 'next/image';

export default function Header() {
    const appUrl = process.env.NEXT_PUBLIC_APP_URL ?? "http://localhost:3000";

    return (
        <header className="container mx-auto px-4 py-6">
            <div className="flex items-center justify-between">
                <Link href="/" className="flex items-center space-x-2">
                    <Image src="/jourflow_logo.png" alt="JourFlow Logo" width={48} height={48} className="h-12 object-contain" />
                    <span className="text-2xl font-bold text-gray-900">JourFlow</span>
                </Link>
                <Link href={`${appUrl}/signin`}>
                    <Button variant="outline">
                        Anmelden
                    </Button>
                </Link>
            </div>
        </header>
    );
}
